import { useEffect } from "react";

const Modal = ({ children, toggleValue, modalClassName }) => {
    useEffect(() => {
        if (toggleValue) {
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, []);
    return (
        <div className={modalClassName} style={{ zIndex: 10000 }}>
            {children}
        </div>
    );
};

export default Modal;
